export const ITEM_TYPES = {
  ACCOUNT: 'accountSelection',
  CHECKBOXES: 'checkboxes',
  DATE: 'date',
  NUMBER: 'number',
  RADIOS: 'radios',
  SELECT: 'select',
  SEPARATOR: 'separator',
  SCALE: 'scale',
  SIGNATURE: 'signature',
  TEXT: 'text',
  IMAGE: 'images',
}

// Contract maximum of visibility rules per conditioned item (Shape-up:
// multiple dependencies, up to three).
export const MAX_VISIBILITY_RULES = 3
